(function initHotspots() {
  document.addEventListener("DOMContentLoaded", function() {
    const hotspots = document.querySelectorAll('.hotspots__item details');

  
    if (!hotspots.length) return;
  
    const observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'open') {
          const details = m.target;
          if (details.hasAttribute('open')) {
            adjustPopup(details);
            setTimeout(() => {
            }, 500)
          }
        }
      }
    });
  
    hotspots.forEach(details => {
      observer.observe(details, { attributes: true });
    });
  
    function adjustPopup(details) {
      const popup = details.querySelector('.hotspots__popup');
      if (!popup) return;
  
      popup.style.left = '';
      popup.style.top = '';
  
      const rect = popup.getBoundingClientRect();
      const viewportW = window.innerWidth;
      const viewportH = window.innerHeight;
      const margin = 0;
      
      let offsetX = 0;
      let offsetY = 0;
  
      if (rect.right > viewportW) {
        offsetX = viewportW - rect.right;
      }
  
      if (rect.bottom > viewportH) {
        offsetY = viewportH - rect.bottom;
      }
  
      if (offsetX !== 0 || offsetY !== 0) {
        const currentLeft = parseFloat(getComputedStyle(popup).left || 0);
        const currentTop = parseFloat(getComputedStyle(popup).top || 0);
        popup.style.left = `${currentLeft + offsetX - 20}px`;
        popup.style.top = `${currentTop + offsetY - 20}px`;
      }
    }
  })

  window.addEventListener('resize', () => {
    document.querySelectorAll('.hotspots__item details[open]').forEach(adjustPopup);
  });
})();